var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4Infirmary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 53h54v10h-4v-6H13v6H9V36h4v17zm52.14-8.16A7.998 7.998 0 0059 42H34.38a7.5 7.5 0 00-5.5 2.84A7.88 7.88 0 0027 50h40a7.88 7.88 0 00-1.86-5.16zM53 32h6v-7h7v-6h-7v-7h-6v7h-7v6h7v7zM23.13 48.91a5 5 0 10-6.193-7.85 5 5 0 006.193 7.85z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Infirmary.b88b7d1e.svg";
export { SvgE4Infirmary as ReactComponent };